// Remove the single-hop ?currency= control param once Shopify has consumed it
// server-side, so it never enters shared/bookmarked URLs, paginate/filter links,
// or the search UI's history writes. Shopify sets cart_currency on this load, so
// refreshing the stripped URL keeps the currency.
(function () {
    try {
        if (!(window.history && window.history.replaceState && window.URL)) return;
        var mdvStripUrl = new URL(window.location.href);
        if (!mdvStripUrl.searchParams.has('currency')) return;
        mdvStripUrl.searchParams.delete('currency');
        window.history.replaceState(window.history.state, document.title,
            mdvStripUrl.pathname + mdvStripUrl.search + mdvStripUrl.hash);
    } catch (mdvStripError) {}
})();


function setCookie(key, value, expiry) {
    var expires = new Date();
    expires.setTime(expires.getTime() + (expiry * 24 * 60 * 60 * 1000));
    document.cookie = key + '=' + value + ';path=/' + ';expires=' + expires.toUTCString();
}
function getCookie(key) {
    var keyValue = document.cookie.match('(^|;) ?' + key + '=([^;]*)(;|$)');
    return keyValue ? keyValue[2] : null;
}
function eraseCookie(key) {
    var keyValue = getCookie(key);
    setCookie(key, keyValue, '-1');
}

const countryOffers = [
    {
        countryCodes: ["GB"],
        offers: [
            "- Free Delivery Over £150",
            "- £2.99 Fixed-Fee UK Postal Returns",
            "- Free In-Store Returns"
        ]
    },
    {
        countryCodes: ["EU","BG","HR","CY","CZ","DK","EE","FI","GR","HU","IE","IT","LV","LT","MT","PL","PT","RO","SK","SI","ES","SE","AT","FR","LU","DE","BE"],
        offers: [
            "- Shipped Locally from Europe",
            "- Free Delivery Over €200",
            "- Express Delivery - Guaranteed delivery within 2 days / €10",
            "- Fixed-Fee Returns from €8"
        ]
    },
    {
        countryCodes: ["NL"],
        offers: [
            "- Shipped from the Netherlands",
            "- Free Delivery Over €200",
            "- Next Day Delivery / €12",
            "- Fixed-Fee Returns from €8"
        ]
    },
    {
        countryCodes: ["CA"],
        offers: [
            "- Free Delivery Over 300 CAD",
            "- Express Delivery - Guaranteed delivery within 6 days",
            "- Import Fees Included at Checkout"
        ]
    },
    {
        countryCodes: ["US"], 
        offers: [
            "- Shipped Locally from U.S.",
            "- No Tariff Charges",
            "- Express Delivery - Guaranteed delivery within 2 days",
            "- Standard Delivery - Guaranteed delivery within 5 days",
            "- Free Delivery Over $250"
        ]
    },
    {
        countryCodes: ["AE"], 
        offers: [
            "- Free Next Day Delivery",
            "- Free Same-Day Delivery Over 400 AED",
            "- Easy Online Returns"
        ]
    },
    {
        countryCodes: ["KW"], 
        offers: [
            "- Standard Delivery",
            "- Free Shipping",
            "- Guaranteed delivery within 5 days."
        ]
    },
    {
        countryCodes: ["SA"],
        offers: [
            "- Standard Delivery",
            "- Free Shipping",
            "- Guaranteed delivery within 8 days."
        ]
    },
    {
        countryCodes: ["CH"],
        offers: [
            "- Free Delivery Over CHF 175"
        ]
    },
    {
        countryCodes: ["NO"],
        offers: [
            "- Free Delivery Over £150",
            "- Tracked International Delivery"
        ]
    },
    {
        countryCodes: ["ME","DZ","AR","BN","BO","BF","KH","CL","GQ","KE","MV","NZ","PK","PE","PY","PA","LK","SC","SN","TN","VN","VE","ZM","ZW","AL","AD","BD","BT","GL","IS","LA","LY","LI","MC","NP","MK","PS","ROW","RS","VA","GI","AM","AZ","BA","BR","CN","CO","DO","EG","GE","GH","HK","IN","ID","IL","IQ","JP","JO","KZ","LB","MY","MA","MX","MD","NG","PH","SG","ZA","KR","TW","TH","TR"],
        offers: [
            "- Tracked International Delivery"
        ]
    },
    {
        countryCodes: ["QA","OM","BH"],
        offers: [
            "- Standard Delivery",
            "- Free Shipping",
            "- Guaranteed delivery within 5 days."
        ]
    },
    {
        countryCodes: ["AU"],
        offers: [
            "- Free delivery over 400 AUD",
            "- Express Delivery - Guaranteed delivery within 4 days"
        ]
    }
];
const countriesLanguages = [
  {
    "country_code": "NL",
    "country_name": "Netherlands",
    "languages": [
      { "name": "Dutch", "code": "gl_language=nl-NL" },
      { "name": "English", "code": "gl_language=en-US" },
      { "name": "French", "code": "gl_language=fr-FR" },
      { "name": "German", "code": "gl_language=de-DE" }
    ]
  },
  {
    "country_code": "FR",
    "country_name": "France",
    "languages": [
      { "name": "French", "code": "gl_language=fr-FR" },
      { "name": "English", "code": "gl_language=en-US" },
      { "name": "Dutch", "code": "gl_language=nl-NL" },
      { "name": "German", "code": "gl_language=de-DE" }
    ]
  },
  {
    "country_code": "LU,BE",
    "country_name": "Luxembourg, Belgium",
    "languages": [
      { "name": "French", "code": "gl_language=fr-FR" },
      { "name": "English", "code": "gl_language=en-US" },
      { "name": "Dutch", "code": "gl_language=nl-NL" },
      { "name": "German", "code": "gl_language=de-DE" }
    ]
  },
  {
    "country_code": "SA,QA,KW",
    "country_name": "Saudi Arabia, Qatar, Kuwait",
    "languages": [
      { "name": "Arabic", "code": "gl_language=ar-AE" },
      { "name": "English", "code": "gl_language=en-US" }
    ]
  },
  {
    "country_code": "AE",
    "country_name": "United Arab Emirates",
    "languages": [
      { "name": "English", "code": "gl_language=en-US" },
      { "name": "Arabic", "code": "gl_language=ar-AE" }
    ]
  },
  {
    "country_code": "AT,DE",
    "country_name": "Austria, Germany",
    "languages": [
      { "name": "German", "code": "gl_language=de-DE" },
      { "name": "French", "code": "gl_language=fr-FR" },
      { "name": "English", "code": "gl_language=en-US" },
      { "name": "Dutch", "code": "gl_language=nl-NL" }
    ]
  },
  {
    "country_code": "ES",
    "country_name": "Spain",
    "languages": [
      { "name": "Spanish", "code": "gl_language=es-ES" },
      { "name": "English", "code": "gl_language=en-US" }
    ]
  },
  {
    "country_code": "IT",
    "country_name": "Italy",
    "languages": [
      { "name": "Italian", "code": "gl_language=it-IT" },
      { "name": "English", "code": "gl_language=en-US" }
    ]
  },
  {
    "country_code": "PT",
    "country_name": "Portugal",
    "languages": [
      { "name": "Portuguese", "code": "gl_language=pt-PT" },
      { "name": "English", "code": "gl_language=en-US" }
    ]
  },
  {
    "country_code": "SE",
    "country_name": "Sweden",
    "languages": [
      { "name": "Swedish", "code": "gl_language=sv-SE" },
      { "name": "English", "code": "gl_language=en-US" }
    ]
  },
  {
    "country_code": "DK",
    "country_name": "Denmark",
    "languages": [
      { "name": "Danish", "code": "gl_language=da-DK" },
      { "name": "English", "code": "gl_language=en-US" }
    ]
  },
  {
    "country_code": "NO",
    "country_name": "Norway",
    "languages": [
      { "name": "Norwegian", "code": "gl_language=nb-NO" },
      { "name": "English", "code": "gl_language=en-US" }
    ]
  },
  {
    "country_code": "FI",
    "country_name": "Finland",
    "languages": [
      { "name": "Finnish", "code": "gl_language=fi-FI" },
      { "name": "English", "code": "gl_language=en-US" }
    ]
  },
  {
    "country_code": "PL",
    "country_name": "Poland",
    "languages": [
      { "name": "Polish", "code": "gl_language=pl-PL" },
      { "name": "English", "code": "gl_language=en-US" }
    ]
  },
  {
    "country_code": "GR",
    "country_name": "Greece",
    "languages": [
      { "name": "Greek", "code": "gl_language=el-GR" },
      { "name": "English", "code": "gl_language=en-US" }
    ]
  },
  {
    "country_code": "RO",
    "country_name": "Romania",
    "languages": [
      { "name": "Romanian", "code": "gl_language=ro-RO" },
      { "name": "English", "code": "gl_language=en-US" }
    ]
  }
];
const countryCurrencyArray = [
  { "US": { "currency": "USD", "country": "United States of America" } },
  { "GB": { "currency": "GBP", "country": "United Kingdom" } },
  { "DE": { "currency": "EUR", "country": "Germany" } },
  { "NL": { "currency": "EUR", "country": "Netherlands" } },
  { "FR": { "currency": "EUR", "country": "France" } },
  { "CA": { "currency": "CAD", "country": "Canada" } },
  { "AU": { "currency": "AUD", "country": "Australia" } },
  { "AL": { "currency": "ALL", "country": "Albania" } },
  { "DZ": { "currency": "DZD", "country": "Algeria" } },
  { "AD": { "currency": "EUR", "country": "Andorra" } },
  { "AM": { "currency": "AMD", "country": "Armenia" } },
  { "AT": { "currency": "EUR", "country": "Austria" } },
  { "AZ": { "currency": "AZN", "country": "Azerbaijan" } },
  { "AR": { "currency": "ARS", "country": "Argentina" } },
  { "BH": { "currency": "AED", "country": "Bahrain" } },
  { "BD": { "currency": "BDT", "country": "Bangladesh" } },
  { "BE": { "currency": "EUR", "country": "Belgium" } },
  { "BT": { "currency": "AED", "country": "Bhutan" } },
  { "BA": { "currency": "BAM", "country": "Bosnia and Herzegovina" } },
  { "BR": { "currency": "BRL", "country": "Brazil" } },
  { "BN": { "currency": "BND", "country": "Brunei" } },
  { "BG": { "currency": "EUR", "country": "Bulgaria" } },
  { "BO": { "currency": "BOB", "country": "Bolivia" } },
  { "BF": { "currency": "AED", "country": "Burkina Faso" } },
  { "KH": { "currency": "KHR", "country": "Cambodia" } },
  { "CN": { "currency": "CNY", "country": "China" } },
  { "CO": { "currency": "COP", "country": "Colombia" } },
  { "HR": { "currency": "EUR", "country": "Croatia" } },
  { "CY": { "currency": "EUR", "country": "Cyprus" } },
  { "CZ": { "currency": "EUR", "country": "Czechia" } },
  { "CL": { "currency": "CLP", "country": "Chile" } },
  { "DK": { "currency": "DKK", "country": "Denmark" } },
  { "DO": { "currency": "DOP", "country": "Dominican Republic" } },
  { "EE": { "currency": "EUR", "country": "Estonia" } },
  { "EG": { "currency": "EGP", "country": "Egypt" } },
  { "GQ": { "currency": "AED", "country": "Equatorial Guinea" } },
  { "FI": { "currency": "EUR", "country": "Finland" } },
  { "GE": { "currency": "GEL", "country": "Georgia" } },
  { "GI": { "currency": "GBP", "country": "Gibraltar" } },
  { "GR": { "currency": "EUR", "country": "Greece" } },
  { "GL": { "currency": "DKK", "country": "Greenland" } },
  { "GH": { "currency": "AED", "country": "Ghana" } },
  { "HK": { "currency": "HKD", "country": "Hong Kong" } },
  { "HU": { "currency": "EUR", "country": "Hungary" } },
  { "IS": { "currency": "ISK", "country": "Iceland" } },
  { "IN": { "currency": "INR", "country": "India" } },
  { "ID": { "currency": "IDR", "country": "Indonesia" } },
  { "IE": { "currency": "EUR", "country": "Ireland" } },
  { "IL": { "currency": "ILS", "country": "Israel" } },
  { "IT": { "currency": "EUR", "country": "Italy" } },
  { "IQ": { "currency": "AED", "country": "Iraq" } },
  { "JP": { "currency": "JPY", "country": "Japan" } },
  { "JO": { "currency": "AED", "country": "Jordan" } },
  { "KW": { "currency": "USD", "country": "Kuwait" } },
  { "KZ": { "currency": "KZT", "country": "Kazakhstan" } },
  { "KE": { "currency": "KES", "country": "Kenya" } },
  { "LA": { "currency": "LAK", "country": "Laos" } },
  { "LV": { "currency": "EUR", "country": "Latvia" } },
  { "LB": { "currency": "LBP", "country": "Lebanon" } },
  { "LY": { "currency": "GBP", "country": "Libya" } },
  { "LI": { "currency": "CHF", "country": "Liechtenstein" } },
  { "LT": { "currency": "EUR", "country": "Lithuania" } },
  { "LU": { "currency": "EUR", "country": "Luxembourg" } },
  { "MY": { "currency": "MYR", "country": "Malaysia" } },
  { "MT": { "currency": "EUR", "country": "Malta" } },
  { "MC": { "currency": "EUR", "country": "Monaco" } },
  { "MA": { "currency": "MAD", "country": "Morocco" } },
  { "MX": { "currency": "MXN", "country": "Mexico" } },
  { "MD": { "currency": "MDL", "country": "Moldova" } },
  { "MV": { "currency": "MVR", "country": "Maldives" } },
  { "NP": { "currency": "NPR", "country": "Nepal" } },
  { "NZ": { "currency": "NZD", "country": "New Zealand" } },
  { "MK": { "currency": "MKD", "country": "North Macedonia" } },
  { "NO": { "currency": "NOK", "country": "Norway" } },
  { "NG": { "currency": "NGN", "country": "Nigeria" } },
  { "OM": { "currency": "AED", "country": "Oman" } },
  { "PK": { "currency": "PKR", "country": "Pakistan" } },
  { "PS": { "currency": "ILS", "country": "Palestinian Territories" } },
  { "PH": { "currency": "PHP", "country": "Philippines" } },
  { "PL": { "currency": "EUR", "country": "Poland" } },
  { "PT": { "currency": "EUR", "country": "Portugal" } },
  { "PE": { "currency": "PEN", "country": "Peru" } },
  { "PY": { "currency": "PYG", "country": "Paraguay" } },
  { "PA": { "currency": "AED", "country": "Panama" } },
  { "QA": { "currency": "QAR", "country": "Qatar" } },
  { "ROW": { "currency": "GBP", "country": "Rest of the World" } },
  { "RO": { "currency": "EUR", "country": "Romania" } },
  { "SA": { "currency": "SAR", "country": "Saudi Arabia" } },
  { "RS": { "currency": "RSD", "country": "Serbia" } },
  { "SG": { "currency": "SGD", "country": "Singapore" } },
  { "SK": { "currency": "EUR", "country": "Slovakia" } },
  { "SI": { "currency": "EUR", "country": "Slovenia" } },
  { "ZA": { "currency": "ZAR", "country": "South Africa" } },
  { "ES": { "currency": "EUR", "country": "Spain" } },
  { "LK": { "currency": "LKR", "country": "Sri Lanka" } },
  { "SE": { "currency": "EUR", "country": "Sweden" } },
  { "CH": { "currency": "CHF", "country": "Switzerland" } },
  { "KR": { "currency": "KRW", "country": "South Korea" } },
  { "SC": { "currency": "SCR", "country": "Seychelles" } },
  { "SN": { "currency": "AED", "country": "Senegal" } },
  { "TW": { "currency": "TWD", "country": "Taiwan" } },
  { "TH": { "currency": "THB", "country": "Thailand" } },
  { "TN": { "currency": "AED", "country": "Tunisia" } },
  { "TR": { "currency": "TRY", "country": "Turkey" } },
  { "AE": { "currency": "AED", "country": "United Arab Emirates" } },
  { "VA": { "currency": "EUR", "country": "Vatican City" } },
  { "VN": { "currency": "VND", "country": "Vietnam" } },
  { "VE": { "currency": "AED", "country": "Venezuela" } },
  { "ZM": { "currency": "ZMW", "country": "Zambia" } },
  { "ZW": { "currency": "AED", "country": "Zimbabwe" } }
];  

// The selectedCountry cookie is domain-wide (.manieredevoir.com), so a country
// chosen on one regional store is still readable on all the others. The redirect
// logic wants that raw cross-store value, but anything DISPLAYING this store's
// own context must not trust it -- otherwise a UAE choice renders a UAE flag and
// UAE delivery copy on the US store. Returns the country only when this store
// actually serves it, else null.
//
// A store answers on several hosts (ME also on ae./sa./kw./qa., EU on
// fr./de./es..., UK on no.), so origin alone would wrongly reject its own
// countries. data-currency is the market code shared by every host of one store.
window.mdvSelectedCountryForThisStore = function mdvSelectedCountryForThisStore() {
  const raw = document.cookie
    .split('; ')
    .find(c => c.startsWith('selectedCountry='))
    ?.split('=')[1];
  if (!raw || !/^[A-Z]{2,3}$/.test(raw)) return null;
  const scope = '.country-selector-select .country-selector-option li';
  const opt = document.querySelector(scope + '[data-code="' + raw + '"]');
  if (!opt) return null;
  const here = document.querySelector(scope + '[data-href="' + location.origin + '"]');
  const market = here && here.getAttribute('data-currency');
  if (opt.getAttribute('data-href') === location.origin
    || (market && opt.getAttribute('data-currency') === market)) return raw;
  return null;
};

function updateCountryFlag() {

 const countryFlags = {
   'AE': 'https://cdn.shopify.com/s/files/1/0282/6678/files/UAE.webp?v=1734340288',
   'QA' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Qatar.webp?v=1734340288',
   'SA' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Saudi_Arabia.webp?v=1734340288',
   'KW' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Kuwait.webp?v=1734340288',
   'AU' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/ef8d72c4-fdf0-11ec-8b88-5254005a3760.png?v=1657253778',
   'IL' : 'https://cdn.shopify.com/s/files/1/0630/4261/7558/files/israel-29-12-2025.png?v=1767011031',
   'DE' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Germany.png?v=1767591709',
   'NL' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Netherlands.png?v=1767591743',
   'FR' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/France.png?v=1767591743',
   'AL' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Albania.png?v=1767591744',
   'DZ' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Algeria.png?v=1767591744',
   'AD' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Andorra.png?v=1767591744',
   'AM' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Armenia.png?v=1767591742',
   'AT' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Austria.png?v=1767591743',
   'AZ' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Azerbaijan.png?v=1767591745',
   'AR' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Argentina.png?v=1767597201',
   'BH' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Bahrain.png?v=1767591743',
   'BD' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Bangladesh.png?v=1767591744',
   'BE' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Belgium.png?v=1767591743',
   'BT' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Bhutan.png?v=1767591744',
   'BA' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Bosnia_and_Herzegovina.png?v=1767591743',
   'BR' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Brazil.png?v=1767591744',
   'BN' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Brunei.png?v=1767591744',
   'BG' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Bulgaria.png?v=1767591743',
   'BO' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Bolivia.png?v=1767591744',
   'BF' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Burkina_Faso.png?v=1767597201',
   'KH' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Cambodia.png?v=1767591744',
   'CN' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/China.png?v=1767591744',
   'CO' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Colombia.png?v=1767591743',
   'HR' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Croatia.png?v=1767591743',
   'CY' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Cyprus.png?v=1767591743',
   'CZ' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Czechia.png?v=1767591743',
   'CL' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Chile.png?v=1767591743',
   'DK' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Denmark.png?v=1767591743',
   'DO' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Dominican_Republic.png?v=1767591744',
   'EE' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Estonia.png?v=1767597201',
   'EG' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Egypt.png?v=1767591744',
   'GQ' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Equatorial_Guinea.png?v=1767591744',
   'FI' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Finland.png?v=1767591742',
   'GE' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Georgia.png?v=1767591743',
   'GI' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Gibraltar.png?v=1767591744',
   'GR' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Greece.png?v=1767591742',
   'GL' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Greenland.png?v=1767591743',
   'GH' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Ghana.png?v=1767591743',
   'HK' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Hong_Kong.png?v=1767591743',
   'HU' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Hungary.png?v=1767597201',
   'IS' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Iceland.png?v=1767591743',
   'IN' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/India.png?v=1767591744',
   'ID' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Indonesia.png?v=1767591743',
   'IE' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Ireland.png?v=1767591744',
   'IT' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Italy.png?v=1767591743',
   'IQ' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Iraq.png?v=1767591744',
   'JP' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Japan.png?v=1767591743',
   'JO' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Jordan.png?v=1767591743',
   'KZ' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Kazakhstan.png?v=1767591744',
   'LV' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Latvia.png?v=1767591743',
   'KE' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Kenya.png?v=1767591744',
   'LA' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Laos.png?v=1767591744',
   'LB' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Lebanon.png?v=1767591743',
   'LY' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Libya.png?v=1767591744',
   'LI' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Liechtenstein.png?v=1767591743',
   'LT' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Lithuania.png?v=1767591744',
   'LU' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Luxembourg.png?v=1767594349',
   'MY' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Malaysia.png?v=1767597201',
   'MT' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Malta.png?v=1767594350',
   'MC' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Monaco.png?v=1767594350',
   'MA' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Morocco.png?v=1767594349',
   'MX' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Mexico.png?v=1767594351',
   'MD' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Moldova.png?v=1767594350',
   'MV' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Maldives.png?v=1767594349',
   'NP' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Nepal.png?v=1767594350',
   'NZ' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/New_Zealand.png?v=1767594349',
   'MK' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/North_Macedonia.png?v=1767594349',
   'NO' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Norway.png?v=1767597200',
   'NG' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Nigeria.png?v=1767594349',
   'OM' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Oman.png?v=1767594350',
   'PS' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Palestinian_Territories.png?v=1767594349',
   'PH' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Philippines.png?v=1767594350',
   'PL' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Poland.png?v=1767594349',
   'PY' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Paraguay.png?v=1767594350',
   'PT' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Portugal.png?v=1767594350',
   'PE' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Peru.png?v=1767594350',
   'PA' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Panama.png?v=1767597201',
   'PK' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Pakistan.png?v=1767594350',
   'ROW' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Rest_of_the_World.png?v=1767596095',
   'RO' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Romania.png?v=1767596093',
   'RS' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Serbia.png?v=1767596094',
   'SG' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Singapore.png?v=1767596093',
   'SK' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Slovakia.png?v=1767596093',
   'SI' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Slovenia.png?v=1767596093',
   'ZA' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/South_Africa.png?v=1767596093',
   'ES' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Spain.png?v=1767597202',
   'LK' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Sri_Lanka.png?v=1767596094',
   'SE' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Sweden.png?v=1767596093',
   'CH' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Switzerland.png?v=1767596093',
   'KR' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/South_Korea.png?v=1767596093',
   'SC' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Seychelles.png?v=1767596093',
   'SN' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Senegal.png?v=1767596092',
   'TW' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Taiwan.png?v=1767596093',
   'TH' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Thailand.png?v=1767596093',
   'TN' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Tunisia.png?v=1767596092',
   'TR' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Turkey.png?v=1767597201',
   'VA' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Vatican_City.png?v=1767596094',
   'VN' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Vietnam.png?v=1767596093',
   'VE' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Venezuela.png?v=1767596093',
   'ZM' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Zambia.png?v=1767596094',
   'ZW' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Zimbabwe.png?v=1767596094',
    };

  /* Exact URL → Flag map */
  const urlFlags = {
    'https://me.manieredevoir.com/': ' https://cdn.shopify.com/s/files/1/0282/6678/files/UAE.webp?v=1734340288',
    'https://ca.manieredevoir.com/': ' https://cdn.shopify.com/s/files/1/0282/6678/files/ef904a58-fdf0-11ec-85db-525400a0165e.png?v=1657253779',
    'https://eu.manieredevoir.com/': ' https://cdn.shopify.com/s/files/1/0282/6678/files/eu-flag.png?v=1639998050',
    'https://us.manieredevoir.com/': 'https://cdn.shopify.com/s/files/1/1604/7647/files/186-united_states.png?v=1621320141',
    'https://uk.manieredevoir.com/': ' https://cdn.shopify.com/s/files/1/1604/7647/files/110-united_kingdom.png?v=1621320141'
    // add remaining URLs here (up to 16)
  };

  const img = document.querySelector('li.country img');
  if (!img) return;

  const countryFlag = window.mdvSelectedCountryForThisStore();

  img.src =
    countryFlags[countryFlag] ||
    urlFlags[location.origin + '/'] ||
    img.src; // fallback = existing flag
}

function setStopRedirect() {
    if (new URLSearchParams(location.search).get('stop_redirect') === 'true') {
        document.cookie = "stop_redirect=true; max-age=" + 7*24*60*60 + "; path=/; domain=.manieredevoir.com; secure";
    }
}

// The prompt used to open only when no country had been chosen at all. But the
// choice is stored domain-wide across all six stores, so a shopper carrying
// another store's country landed in a mismatched context AND was never asked --
// the cookie's presence silently suppressed the prompt. Ask in that case too,
// once per session so a deliberate dismissal sticks for the visit.
function shouldOpenCountrySelector() {
  var stored = getCookie("selectedCountry");
  // Cookieless first visits are handled by mdvMaybeGeoOpen_, which prompts ONLY
  // on a genuine store mismatch. Returning true here is what made this modal fire
  // for every new visitor regardless of whether they were already in the right place.
  if (!stored) return false;
  // If this host isn't represented in the selector we can't tell which market
  // it is, and every stored country would look foreign. Stay quiet rather than
  // prompt shoppers who are already in the right place.
  if (!document.querySelector('.country-selector-select .country-selector-option li[data-href="' + location.origin + '"]')) return false;
  // A stored choice this store actually serves is honoured silently.
  if (typeof window.mdvSelectedCountryForThisStore !== 'function') return false;
  if (window.mdvSelectedCountryForThisStore()) return false;
  // stop_redirect is the QA/dev escape hatch; it suppresses this too.
  if (getCookie("stop_redirect")) return false;
  // They already declined this exact mismatch recently. Keyed to the country so
  // a NEW unserved country asks again, and host-only so declining on one store
  // doesn't silence the others.
  if (getCookie("mdvMismatchDismissed") === stored) return false;
  try {
    if (sessionStorage.getItem('mdvCountryMismatchPrompted') === '1') return false;
    sessionStorage.setItem('mdvCountryMismatchPrompted', '1');
  } catch (_) {
    return false; // storage blocked (private mode) -- stay quiet rather than nag every page
  }
  return true;
}

// The page-load reconcile (syncCurrencySelectorToActive, the last call in
// runCountryFunctions) overwrites the country-derived currency with Shopify's
// active one, so an auto-opened prompt can show "United States of America"
// beside "GBP". Re-apply the currency for the country actually selected,
// immediately before showing the modal. Named so every open path can share it.
// Which market a country belongs to, read from the selector's own markup.
function mdvMarketForCountry_(code) {
    var li = document.querySelector('.country-selector-select .country-selector-option li[data-code="' + code + '"]');
    return li ? li.getAttribute('data-currency') : null;
}
// Which market THIS storefront is, matched on origin so alias hosts resolve correctly.
function mdvCurrentMarket_() {
    var li = document.querySelector('.country-selector-select .country-selector-option li[data-href="' + location.origin + '"]');
    return li ? li.getAttribute('data-currency') : null;
}
// Prompt a cookieless first-time visitor ONLY when their detected country belongs
// to a different STORE (market-level, not country-level: a UK customer browsing
// from Spain is not prompted). Opens when geo resolves, with a 1500ms floor from
// navigation so it never lands on a half-painted page, and a 5000ms cutoff after
// which we stay quiet rather than interrupt someone already reading. The session
// flag is deliberately NOT set on the cutoff path, so the next page may still ask.
function mdvMaybeGeoOpen_(detectedRaw) {
    try {
        var detected = String(detectedRaw || '').toUpperCase();
        if (!/^[A-Z]{2}$/.test(detected)) return;
        if (getCookie('selectedCountry')) return;
        if (getCookie('stop_redirect')) return;
        if (navigator && navigator.webdriver) return;
        var here = mdvCurrentMarket_();
        var there = mdvMarketForCountry_(detected);
        if (!here || !there || here === there) return;
        if (getCookie('mdvGeoDismissed') === detected) return;
        try {
            if (sessionStorage.getItem('mdvGeoPrompted') === '1') return;
        } catch (mdvGeoStorageError) { return; }
        var elapsed = (window.performance && performance.now) ? performance.now() : 1500;
        if (elapsed > 5000) return;
        setTimeout(function mdvGeoOpen() {
            try {
                if ($('.country-selector.custom-country-selector').hasClass('active')) return;
                try { sessionStorage.setItem('mdvGeoPrompted', '1'); } catch (mdvGeoSetError) {}
                mdvPrefillCurrencyForSelectedCountry_();
                window.mdvGeoPromptOpen = detected;
                $('.country-selector.custom-country-selector').addClass('active');
                $('body').addClass('no-scroll');
            } catch (mdvGeoOpenError) {}
        }, Math.max(0, 1500 - elapsed));
    } catch (mdvGeoError) {}
}
function mdvPrefillCurrencyForSelectedCountry_() {
    try {
        var mdvOpenCountry = $('.country-selector-select .country-selector-option li.active').attr('data-code');
        if (mdvOpenCountry) getCurrencyByCountryCode(mdvOpenCountry);
    } catch (mdvPrefillError) {}
}

// ---------------------------------------------------------------------------
// Cross-store guidance: a slim fixed top banner for a cookieless visitor whose
// detected market is not this store's, plus an inline notice on the cart page.
//
// This REPLACES the geo-modal auto-open: mdvMaybeGeoOpen_ is no longer invoked
// (the function is left defined but dead, so the modal machinery it shares with
// the header-opened selector and the stored-choice mismatch prompt is untouched).
//
// Layout contract: the banner is fixed at the top, the header's `top` is offset
// by the banner height, AND .main-wrapper is padded by the same amount. All
// three move together. The padding is what stops the header -- which is a
// TRANSPARENT overlay on the collection templates -- from overprinting the
// collection title and item count, which a header-offset-only approach did.
//
// Every entry point below is fail-quiet: any throw leaves the page exactly as it
// was -- no banner, no notice, nothing else affected.
//
// Marker literal for post-publish grep verification: 'mdvGeoBanner'.
// ---------------------------------------------------------------------------

// The selector markup names COUNTRIES, never stores. Its <li>s carry data-code
// (country code), value (country NAME), data-href (store origin) and
// data-currency (market code: UK/US/EU/CA/ME/AU). There is no store display name
// anywhere in the DOM -- verified by dumping every attribute on all 110 <li>s --
// so the six market codes are mapped here. A market code absent from this map
// renders NOTHING at all rather than interpolating undefined into shopper copy.
var mdvStoreNames_ = {
    UK: 'UK',
    US: 'US',
    EU: 'Europe',
    CA: 'Canada',
    ME: 'Middle East',
    AU: 'Australia'
};

// Resolve the mismatch into everything the copy and the CTA need, or null if any
// part is unknown. Shared by the banner and the cart notice so they can never
// disagree about which store they are pointing at.
function mdvGuidanceContext_(detectedRaw) {
    try {
        var detected = String(detectedRaw || '').toUpperCase();
        if (!/^[A-Z]{2}$/.test(detected)) return null;
        // mdvCurrentMarket_ matches on origin, so it is already null when this
        // host is absent from the selector markup -- the "we cannot tell which
        // market this is" case, where every country would look foreign.
        var here = mdvCurrentMarket_();
        var there = mdvMarketForCountry_(detected);
        if (!here || !there || here === there) return null;
        // Unknown-code guard: both ends must be nameable.
        var currentName = mdvStoreNames_[here];
        var targetName = mdvStoreNames_[there];
        if (!currentName || !targetName) return null;
        var targetLi = document.querySelector('.country-selector-select .country-selector-option li[data-code="' + detected + '"]');
        var targetHref = targetLi && targetLi.getAttribute('data-href');
        if (!targetHref || targetHref === location.origin) return null;
        return {
            detected: detected,
            currentName: currentName,
            targetName: targetName,
            targetHref: targetHref
        };
    } catch (mdvGuidanceCtxError) {
        return null;
    }
}

// The charged currency for the cart notice's "(... pricing)" fragment. The
// markup's data-currency holds MARKET codes (CA, ME), not currencies, so it must
// not be used here. Null = drop the parenthetical rather than guess.
function mdvGuidanceCurrency_() {
    try {
        if (window.Shopify && Shopify.currency && /^[A-Z]{3}$/.test(String(Shopify.currency.active))) {
            return Shopify.currency.active;
        }
    } catch (mdvGuidanceCcyError) {}
    return null;
}

// Session cache of a SUCCESSFUL mount. The first qualifying pageview always
// waits for the /browsing_context_suggestions.json round-trip and takes the one
// content jump; only once the banner is actually in the DOM is the verdict
// stored. Later pageviews then apply the layout compensation at script-execution
// time -- before first paint -- so the reserved band is already there when the
// page paints and nothing shifts.
//
// mountedOK is the whole point: caching a verdict that never produced a banner
// would reserve space on later pageviews for a bar that never arrives. Storage
// throws (private mode) skip the early path entirely and degrade to late mount.
//
// The cache is a shortcut past the network, never past a guard: every
// suppression is re-read synchronously before the early path is honoured.
var mdvGuidanceCacheKey_ = 'mdvGeoBannerSession';
function mdvGuidanceCacheRead_() {
    try {
        var mdvRaw = sessionStorage.getItem(mdvGuidanceCacheKey_);
        if (!mdvRaw) return null;
        var mdvParsed = JSON.parse(mdvRaw);
        if (!mdvParsed || mdvParsed.mountedOK !== true) return null;
        if (!/^[A-Z]{2}$/.test(String(mdvParsed.detectedCountry || ''))) return null;
        return mdvParsed;
    } catch (mdvGuidanceCacheReadError) {
        return null;
    }
}
function mdvGuidanceCacheWrite_(ctx) {
    try {
        sessionStorage.setItem(mdvGuidanceCacheKey_, JSON.stringify({
            detectedCountry: ctx.detected,
            resolvedTargetHref: ctx.targetHref,
            mountedOK: true
        }));
    } catch (mdvGuidanceCacheWriteError) {}
}
function mdvGuidanceCacheClear_() {
    try { sessionStorage.removeItem(mdvGuidanceCacheKey_); } catch (mdvGuidanceCacheClearError) {}
}

// Switching stores writes selectedCountry with EXACTLY the attributes the Update
// button uses (365 days, domain-wide, secure) -- a host-only write here would
// shadow the domain-wide cookie on this host and strand the shopper. Writing it
// is also what arms the existing auto-route flow for the destination.
function mdvGuidanceSwitch_(ctx) {
    try {
        document.cookie = "selectedCountry=" + ctx.detected + "; expires=" + new Date(Date.now() + 365*24*60*60*1000).toUTCString() + "; path=/; domain=.manieredevoir.com; secure";
        // Allowlisted builder only: it validates the destination, drops the
        // single-hop country/currency params and preserves the path and UTMs.
        // Any throw aborts to a no-op rather than hand-building a URL.
        if (!window.MDVMarketRedirect) throw new Error('MDVMarketRedirect unavailable');
        var mdvUrl = window.MDVMarketRedirect.buildMarketRedirectUrl(ctx.targetHref, window.location.href);
        if (!mdvUrl) return;
        window.location.href = mdvUrl;
    } catch (mdvGuidanceSwitchError) {}
}

var mdvGuidanceWarned_ = false;
// Fail-closed header guard. The banner offsets the header rather than padding the
// body, so it must be certain which element the header is and that it really is
// pinned to the top -- otherwise a fixed bar would sit over the navigation on a
// layout we do not recognise. Anything unexpected mounts nothing.
function mdvGuidanceHeader_() {
    try {
        var mdvEl = document.querySelector('.shopify-section.main_header');
        if (!mdvEl) return null;
        var mdvCs = window.getComputedStyle(mdvEl);
        // sticky on collection/cart/product templates, fixed on index -- both are
        // top-anchored and both accept the offset.
        if (mdvCs.position !== 'fixed' && mdvCs.position !== 'sticky') return null;
        var mdvTop = parseFloat(mdvCs.top);
        if (!isFinite(mdvTop)) return null;
        // Two legitimate readings: 0 on a fresh page, or exactly the reserved
        // height when the early path has ALREADY applied our own offset. Without
        // the second case this guard would reject the very state it created and
        // abort every pre-compensated mount. Anything else is an unknown layout
        // and still fails closed.
        var mdvReserved = 0;
        try {
            mdvReserved = parseFloat(window.getComputedStyle(document.documentElement)
                .getPropertyValue('--mdv-region-guidance-height')) || 0;
        } catch (mdvGuidanceVarError) { mdvReserved = 0; }
        if (Math.abs(mdvTop) > 1 && !(mdvReserved && Math.abs(mdvTop - mdvReserved) <= 1)) return null;
        return mdvEl;
    } catch (mdvGuidanceHeaderError) {
        return null;
    }
}
function mdvGuidanceWarnOnce_() {
    if (mdvGuidanceWarned_) return;
    mdvGuidanceWarned_ = true;
    try {
        if (window.console && console.warn) {
            console.warn('mdvGeoBanner not mounted: the sticky header did not resolve to a top-anchored element, so the bar would have covered the navigation.');
        }
    } catch (mdvGuidanceWarnError) {}
}

var mdvGuidanceStyleId_ = 'mdvGeoBanner-styles';
function mdvGuidanceStyles_() {
    try {
        if (document.getElementById(mdvGuidanceStyleId_)) return;
        var mdvStyle = document.createElement('style');
        mdvStyle.id = mdvGuidanceStyleId_;
        mdvStyle.textContent = [
            ":root{--mdv-region-guidance-height:46px}",
            // Logical properties (inset-inline / padding-inline / border-inline-start)
            // so an RTL document mirrors the bar without a second rule set.
            ".mdvGeoBanner{align-items:center;background:#4B3E3C;box-sizing:border-box;color:#FAF9F7;display:grid;gap:18px;grid-template-columns:minmax(0,1fr) auto 44px;height:46px;inset-inline:0;padding-inline:40px 0;position:fixed;top:0;z-index:20}",
            // The theme title-cases inherited copy, which mangles the approved
            // sentence-case strings ("You're Shopping The Canada Store"). Reset is
            // scoped strictly to this component's own subtree.
            ".mdvGeoBanner,.mdvGeoBanner *,.mdvGeoBanner-cart-notice,.mdvGeoBanner-cart-notice *{text-transform:none;font-style:normal;font-variant:normal}",
            ".mdvGeoBanner-message{color:#FAF9F7;font-family:'MADE Mirage',Georgia,serif;font-size:12px;font-weight:400;letter-spacing:1px;line-height:16.5px;margin:0;min-width:0}",
            ".mdvGeoBanner-cta{align-items:center;background:transparent;border:1px solid #D8D3D0;border-radius:0;box-sizing:border-box;color:#FAF9F7;cursor:pointer;display:inline-flex;font-family:'MADE Mirage',Georgia,serif;font-size:11px;font-weight:500;height:32px;justify-content:center;letter-spacing:1px;line-height:15px;padding:0 20px;text-decoration:none;white-space:nowrap}",
            ".mdvGeoBanner-dismiss{align-items:center;background:transparent;border:0;border-inline-start:1px solid #655A58;border-radius:0;color:#FAF9F7;cursor:pointer;display:inline-flex;font-family:Montserrat,Arial,sans-serif;font-size:16px;font-weight:400;height:44px;justify-content:center;padding:0;width:44px}",
            ".mdvGeoBanner-cta:focus-visible,.mdvGeoBanner-dismiss:focus-visible,.mdvGeoBanner-cart-link:focus-visible{outline:2px solid #FAF9F7;outline-offset:-4px}",
            // EVERY offset hangs off one class on <html>. That is what lets the
            // early (pre-paint) path and the DOMContentLoaded path produce
            // identical computed layout: both do nothing but toggle this class,
            // and the early path needs no element queries to do it.
            // The header is offset so the fixed bar never covers its controls...
            ".mdvGeoBanner-active .shopify-section.main_header{top:var(--mdv-region-guidance-height)!important}",
            // ...and the content is padded by the SAME amount so the offset header
            // does not overprint the page. .main-wrapper carries transition:all in
            // the theme, so the transition is pinned off to keep this instant.
            ".mdvGeoBanner-active .main-wrapper{padding-top:var(--mdv-region-guidance-height)!important;transition:none!important}",
            // mdv-search-v2.css pins the search panel to the header height. Those
            // pins are mirrored here, each shifted by the bar height, so the panel
            // stays flush under the offset header instead of leaving a sliver of
            // empty header above it. Additive and keyed to the banner-active class:
            // remove the class and the panel is exactly as it is today. The 62/73px
            // literals are OWNED BY mdv-search-v2.css -- if that file changes its
            // pins, these mirrors go stale and the cosmetic sliver can return.
            ".mdvGeoBanner-active .search-desk-box{top:calc(var(--mdv-header-height, 61px) + var(--mdv-region-guidance-height))}",
            ".mdvGeoBanner-cart-notice{background:#655A58;border-block:1px solid #4B3E3C;box-sizing:border-box;color:#FAF9F7;margin:0 0 8px;padding:8px 24px;text-align:center;width:100%}",
            ".mdvGeoBanner-cart-copy{color:#FAF9F7;font-family:'MADE Mirage',Georgia,serif;font-size:12px;font-weight:400;letter-spacing:.96px;line-height:16.5px;margin:0;text-align:center}",
            ".mdvGeoBanner-cart-link{background:none;border:0;color:#FAF9F7;cursor:pointer;display:inline-block;font-family:'MADE Mirage',Georgia,serif;font-size:11px;font-weight:400;letter-spacing:.96px;line-height:15.6px;margin:2px 0 0;padding:0;text-align:center;text-decoration:underline;text-decoration-thickness:1px;text-underline-offset:3px;transition:none;vertical-align:baseline;width:auto}",
            "@media only screen and (min-width:991px){",
            ".mdvGeoBanner-active .template-index .search-desk-box{top:calc(62px + var(--mdv-region-guidance-height))}",
            ".mdvGeoBanner-active .template-index header.header.head-sticky .search-desk-box{top:calc(73px + var(--mdv-region-guidance-height))}",
            "}",
            "@media only screen and (max-width:767px){",
            ":root{--mdv-region-guidance-height:62px}",
            ".mdvGeoBanner{gap:8px;height:62px;padding-inline:12px 0}",
            ".mdvGeoBanner-message{display:-webkit-box;font-size:11px;letter-spacing:.5px;line-height:14px;overflow:hidden;-webkit-box-orient:vertical;-webkit-line-clamp:2}",
            ".mdvGeoBanner-cta{font-size:10px;height:36px;line-height:13.75px;padding-inline:11px}",
            ".mdvGeoBanner-cart-notice{padding:7px 15px}",
            ".mdvGeoBanner-cart-copy,.mdvGeoBanner-cart-link{font-size:11px;line-height:14px}",
            // Mobile keeps the verified layout: full-width notice, link on its
            // own line so it stays a comfortable tap target.
            ".mdvGeoBanner-cart-link{display:block;margin-top:4px}",
            ".mdvGeoBanner-active .search-desk-box{top:calc(var(--mdv-header-height, 65px) + var(--mdv-region-guidance-height))}",
            "}"
        ].join('');
        (document.head || document.documentElement).appendChild(mdvStyle);
    } catch (mdvGuidanceStyleError) {}
}

// Drops the compensation. One class off <html> takes the header offset, the
// wrapper padding and the search pins with it, so the page is back to baseline
// in a single step whichever path applied them.
function mdvGuidanceRevert_() {
    try {
        document.documentElement.classList.remove('mdvGeoBanner-active');
        mdvGuidanceCacheClear_();
    } catch (mdvGuidanceRevertError) {}
}

function mdvGuidanceRemoveBanner_() {
    try {
        var mdvEl = document.getElementById('mdvGeoBanner');
        if (mdvEl && mdvEl.parentNode) mdvEl.parentNode.removeChild(mdvEl);
        mdvGuidanceRevert_();
    } catch (mdvGuidanceRemoveError) {}
}

// Mandatory fail-closed check, run after the DOMContentLoaded mount attempt.
// The question asked is "is the banner in the DOM right now" -- read back from
// getElementById, never inferred from which branch the mount took -- so any exit
// path that leaves reserved space with no bar collapses it immediately. No retry:
// the cache is cleared, so the next pageview simply late-mounts from scratch.
function mdvGuidanceVerifyMounted_() {
    try {
        if (!document.documentElement.classList.contains('mdvGeoBanner-active')) return;
        if (document.getElementById('mdvGeoBanner')) return;
        mdvGuidanceRevert_();
    } catch (mdvGuidanceVerifyError) {}
}

function mdvGuidanceMountBanner_(ctx) {
    try {
        if (document.getElementById('mdvGeoBanner')) return;
        var mdvHeader = mdvGuidanceHeader_();
        if (!mdvHeader) { mdvGuidanceWarnOnce_(); return; }

        mdvGuidanceStyles_();

        var mdvBanner = document.createElement('aside');
        mdvBanner.id = 'mdvGeoBanner';
        mdvBanner.className = 'mdvGeoBanner';
        mdvBanner.setAttribute('aria-label', 'Regional store suggestion');
        mdvBanner.setAttribute('dir', 'auto');

        var mdvMessage = document.createElement('p');
        mdvMessage.className = 'mdvGeoBanner-message';
        mdvMessage.textContent = "You're shopping the " + ctx.currentName + " store — switch to the " + ctx.targetName + " store?";

        var mdvCta = document.createElement('button');
        mdvCta.type = 'button';
        mdvCta.className = 'mdvGeoBanner-cta';
        mdvCta.textContent = 'Switch store';
        // WCAG 2.5.3 Label in Name: the accessible name must START with the
        // visible label, or voice control ("click Switch store") can fail to
        // match. The destination is kept after the prefix so screen readers
        // still announce where the control goes.
        mdvCta.setAttribute('aria-label', 'Switch store \u2014 ' + ctx.targetName + ' store');
        mdvCta.addEventListener('click', function mdvGuidanceCtaClick() {
            // Leaving for the other store: this session's verdict is spent.
            mdvGuidanceCacheClear_();
            mdvGuidanceSwitch_(ctx);
        });

        var mdvDismiss = document.createElement('button');
        mdvDismiss.type = 'button';
        mdvDismiss.className = 'mdvGeoBanner-dismiss';
        mdvDismiss.setAttribute('aria-label', 'Dismiss regional store suggestion');
        mdvDismiss.textContent = '×';
        mdvDismiss.addEventListener('click', function mdvGuidanceDismissClick() {
            // Snoozed for 30 days for THIS detected country, so a different
            // country still asks. Own cookie, separate from the retired modal's
            // mdvGeoDismissed, which is still honoured for existing snoozes.
            try { setCookie('mdvGeoBannerDismissed', ctx.detected, '30'); } catch (mdvGuidanceCookieError) {}
            mdvGuidanceRemoveBanner_();
        });

        mdvBanner.appendChild(mdvMessage);
        mdvBanner.appendChild(mdvCta);
        mdvBanner.appendChild(mdvDismiss);

        // One lifecycle step for header offset, content compensation and search
        // pins -- idempotent, so it is a no-op when the early path already set it.
        document.documentElement.classList.add('mdvGeoBanner-active');
        document.body.appendChild(mdvBanner);

        // Cache ONLY once the bar is genuinely in the DOM, so a later pageview can
        // never reserve space for a banner that failed to mount.
        if (document.getElementById('mdvGeoBanner')) mdvGuidanceCacheWrite_(ctx);
    } catch (mdvGuidanceMountError) {}
}

// Cart page only. The mini-cart drawer reuses .min-cart-footer .min-cart-bottom
// and lives inside header.header on EVERY page, so anchor presence alone would
// scatter this notice site-wide: gate on the path, then scope to the on-page
// cart (.min-cart.cart-page), which exists only on /cart.
function mdvGuidanceIsCartPage_() {
    try {
        return /^(\/[a-z]{2}(-[a-z]{2})?)?\/cart\/?$/i.test(location.pathname);
    } catch (mdvGuidanceCartPathError) {
        return false;
    }
}

function mdvGuidanceMountCartNotice_(ctx) {
    try {
        if (!mdvGuidanceIsCartPage_()) return;
        // A stored country this store actually serves means there is no mismatch
        // to warn about, whatever geo detected.
        if (typeof window.mdvSelectedCountryForThisStore === 'function'
            && window.mdvSelectedCountryForThisStore()) {
            return;
        }
        // Width alignment is structural, not measured. .min-cart-bottom carries
        // padding:0 20px and the checkout button is width:100% inside it, so a
        // width:100% block placed in that same container gets the CTA's exact
        // left/right edges -- and keeps them through any resize, with no JS.
        // Sitting outside it (the previous sibling position) overhung the CTA by
        // 20px each side.
        var mdvBottom = document.querySelector('.min-cart.cart-page .min-cart-footer .min-cart-bottom');
        if (!mdvBottom) return;
        // Anchor on the CTA itself; fall back to the container only if the button
        // markup changes, so a layout shift can never silently drop the warning.
        var mdvAnchor = mdvBottom.querySelector('.btn.min-cart-checkout') || mdvBottom;
        if (!mdvAnchor.parentNode) return;

        // Exactly one instance: an AJAX cart re-render replaces the footer, so
        // drop any stale copies, and no-op when one is already in the right place.
        var mdvExisting = document.querySelectorAll('#mdvGeoBanner-cart-notice, .mdvGeoBanner-cart-notice');
        var mdvKeep = null;
        for (var mdvI = 0; mdvI < mdvExisting.length; mdvI++) {
            if (!mdvKeep && mdvExisting[mdvI].nextElementSibling === mdvAnchor) {
                mdvKeep = mdvExisting[mdvI];
            } else if (mdvExisting[mdvI].parentNode) {
                mdvExisting[mdvI].parentNode.removeChild(mdvExisting[mdvI]);
            }
        }
        if (mdvKeep) return;

        mdvGuidanceStyles_();

        var mdvNotice = document.createElement('aside');
        mdvNotice.id = 'mdvGeoBanner-cart-notice';
        mdvNotice.className = 'mdvGeoBanner-cart-notice';
        mdvNotice.setAttribute('aria-label', 'Regional store checkout notice');
        mdvNotice.setAttribute('dir', 'auto');

        var mdvCurrency = mdvGuidanceCurrency_();
        var mdvCopy = document.createElement('p');
        mdvCopy.className = 'mdvGeoBanner-cart-copy';
        mdvCopy.textContent = "Heads up — this is our " + ctx.currentName + " store"
            + (mdvCurrency ? " (" + mdvCurrency + " pricing)" : "")
            + ". Prefer the " + ctx.targetName + " store? Your basket won't transfer if you switch.";

        // This control navigates, so it is a real <a href>. The destination is
        // resolved once here through the allowlisted builder, which validates the
        // host, drops the single-hop control params and keeps the path and UTMs.
        // Nothing in .min-cart-bottom styles anchors as buttons (verified: no
        // background, border or padding), so the scoped overrides on this class
        // are enough to keep it reading as a quiet text link.
        var mdvHref = null;
        try {
            if (window.MDVMarketRedirect) {
                mdvHref = window.MDVMarketRedirect.buildMarketRedirectUrl(ctx.targetHref, window.location.href);
            }
        } catch (mdvGuidanceHrefError) { mdvHref = null; }

        // Arm the destination store, synchronously, before the browser leaves.
        // Runs for a plain click AND for cmd/ctrl-click (both fire click).
        var mdvArm = function mdvGuidanceCartArm() {
            try {
                document.cookie = "selectedCountry=" + ctx.detected + "; expires=" + new Date(Date.now() + 365*24*60*60*1000).toUTCString() + "; path=/; domain=.manieredevoir.com; secure";
            } catch (mdvGuidanceArmCookieError) {}
            mdvGuidanceCacheClear_();
        };

        var mdvLink;
        if (mdvHref) {
            mdvLink = document.createElement('a');
            mdvLink.className = 'mdvGeoBanner-cart-link';
            mdvLink.href = mdvHref;
            mdvLink.textContent = 'Switch to the ' + ctx.targetName + ' store';
            // Native semantics: no preventDefault, no keyboard handler -- Enter
            // and AT activation are the browser's job on a real link.
            //
            // Arm ONLY on a plain primary click, i.e. the one case where this tab
            // is actually leaving. A modified click (cmd/ctrl/shift, or middle)
            // opens the destination in a NEW tab and leaves the shopper here on
            // CA: writing the domain-wide selectedCountry cookie then would make
            // mdvMaybeApplyStoredCountry_ auto-route THIS tab away on its next
            // navigation, stranding the basket they deliberately kept. The href
            // alone still lands the new tab on the correct store, where a
            // matching-market visitor is prompted for nothing.
            mdvLink.addEventListener('click', function mdvGuidanceCartClick(mdvEvent) {
                if (!mdvEvent) return;
                if (mdvEvent.metaKey || mdvEvent.ctrlKey || mdvEvent.shiftKey || mdvEvent.button !== 0) return;
                mdvArm();
            });
        } else {
            // No allowlisted URL could be built, so there is no href to give.
            // Fall back to the verified span+role=button, which navigates in JS.
            mdvLink = document.createElement('span');
            mdvLink.className = 'mdvGeoBanner-cart-link';
            mdvLink.setAttribute('role', 'button');
            mdvLink.setAttribute('tabindex', '0');
            mdvLink.textContent = 'Switch to the ' + ctx.targetName + ' store';
            var mdvLinkActivate = function mdvGuidanceCartLinkClick() {
                mdvGuidanceCacheClear_();
                mdvGuidanceSwitch_(ctx);
            };
            mdvLink.addEventListener('click', mdvLinkActivate);
            mdvLink.addEventListener('keydown', function mdvGuidanceCartLinkKey(mdvEvent) {
                if (mdvEvent.key === 'Enter' || mdvEvent.key === ' ' || mdvEvent.key === 'Spacebar') {
                    mdvEvent.preventDefault();
                    mdvLinkActivate();
                }
            });
        }

        // Copy centred on its own line(s), link centred on the line below. The
        // copy is a block, so the link starts a new line naturally -- no <br>.
        mdvNotice.appendChild(mdvCopy);
        mdvNotice.appendChild(mdvLink);
        mdvAnchor.parentNode.insertBefore(mdvNotice, mdvAnchor);
    } catch (mdvGuidanceCartError) {}
}

// Created on the CART PAGE ONLY -- that is the only place an AJAX re-render can
// destroy the notice. rAF-debounced, and the mount no-ops when the notice is
// already in place, so the observer settles instead of looping on its own write.
var mdvGuidanceObserver_ = null;
var mdvGuidanceQueued_ = false;
function mdvGuidanceObserve_(ctx) {
    try {
        if (!mdvGuidanceIsCartPage_()) return;
        if (mdvGuidanceObserver_ || !window.MutationObserver) return;
        mdvGuidanceObserver_ = new MutationObserver(function mdvGuidanceMutated() {
            if (mdvGuidanceQueued_) return;
            mdvGuidanceQueued_ = true;
            var mdvRun = function mdvGuidanceRerun() {
                mdvGuidanceQueued_ = false;
                mdvGuidanceMountCartNotice_(ctx);
            };
            if (window.requestAnimationFrame) window.requestAnimationFrame(mdvRun);
            else setTimeout(mdvRun, 16);
        });
        mdvGuidanceObserver_.observe(document.body, { childList: true, subtree: true });
    } catch (mdvGuidanceObserveError) {}
}

// Entry point, called with the geo-detected country in place of the retired
// mdvMaybeGeoOpen_. Renders whenever geo resolves -- there is no time cutoff,
// because a bar that appears late is merely late, not an interruption.
function mdvMaybeShowGuidance_(detectedRaw) {
    try {
        // Guards ahead of ALL mounting -- these suppress the cart notice as well
        // as the banner. stop_redirect is the QA/dev escape hatch; webdriver is
        // automation and crawlers, which must never see either component.
        if (getCookie('stop_redirect')) return;
        if (navigator && navigator.webdriver) return;

        var mdvCtx = mdvGuidanceContext_(detectedRaw);
        if (!mdvCtx) return;

        // The cart notice is deliberately NOT suppressed by the dismissal
        // snoozes: dismissing a suggestion on a product page should not hide a
        // basket-won't-transfer warning at the point of checkout.
        mdvGuidanceMountCartNotice_(mdvCtx);
        mdvGuidanceObserve_(mdvCtx);

        // Banner lifecycle stops here on the cart page: the notice above is the
        // sole regional element at the point of checkout, and the shopper needs
        // the space for the CTA. Exiting here is NOT a mount failure -- no class
        // was applied, so mdvGuidanceVerifyMounted_ has nothing to revert, and
        // the cache is left exactly as it was.
        if (mdvGuidanceIsCartPage_()) return;

        if (getCookie('selectedCountry')) return;
        if (getCookie('mdvGeoBannerDismissed') === mdvCtx.detected) return;
        // Honour snoozes left by the retired modal prompt.
        if (getCookie('mdvGeoDismissed') === mdvCtx.detected) return;

        mdvGuidanceMountBanner_(mdvCtx);
    } catch (mdvGuidanceError) {}
}

// Every suppression that can be read WITHOUT touching the DOM. The early path
// runs before there is a document to query, so this is the whole guard set
// available to it; the DOM-dependent checks (market mismatch, header shape)
// still run later at mount time.
function mdvGuidanceSuppressedSync_(detected) {
    try {
        if (getCookie('selectedCountry')) return true;
        if (getCookie('stop_redirect')) return true;
        // ?stop_redirect=true is honoured on the very load it appears on, before
        // setStopRedirect has had a chance to persist it as a cookie.
        if (/[?&]stop_redirect=true/i.test(location.search)) return true;
        if (getCookie('mdvGeoBannerDismissed') === detected) return true;
        if (getCookie('mdvGeoDismissed') === detected) return true;
        if (navigator && navigator.webdriver) return true;
        return false;
    } catch (mdvGuidanceSuppressError) {
        return true;
    }
}

// Synchronous DOMContentLoaded path for a cached session. Runs the identical
// guard chain -- a cached verdict is a shortcut past the network round-trip,
// never past a snooze or a newly-set country.
function mdvMaybeShowGuidanceCached_() {
    try {
        var mdvCached = mdvGuidanceCacheRead_();
        if (!mdvCached) return;
        mdvMaybeShowGuidance_(mdvCached.detectedCountry);
    } catch (mdvGuidanceCachedError) {}
}

// ---------------------------------------------------------------------------
// EARLY PATH -- runs at script-execution time, before first paint.
//
// On a session where the banner has already mounted once, the layout
// compensation is applied here so the page paints with the band already
// reserved and nothing jumps. It touches nothing but documentElement's class
// list and a <style> element: no element queries, no mounting, no measurement.
// The bar itself still mounts at DOMContentLoaded, into the reserved space.
//
// The header is a transparent overlay, so between paint and DCL the reserved
// band simply shows through as empty. That is the accepted trade for removing
// the jump.
//
// If the DCL mount then fails for any reason, mdvGuidanceVerifyMounted_ tears
// this back down in the same tick.
// ---------------------------------------------------------------------------
(function mdvGuidanceEarlyCompensation_() {
    try {
        // The cart page never runs the banner lifecycle, so it must not reserve
        // space for one either. Gated FIRST, before the cache is even read: this
        // is a deliberate skip, not a failed mount, so nothing is written or
        // cleared and the session's verdict survives for the next non-cart page.
        // Same predicate the notice gate uses -- one function, so the two can
        // never disagree about what a cart URL is.
        if (mdvGuidanceIsCartPage_()) return;
        var mdvCached = mdvGuidanceCacheRead_();
        if (!mdvCached) return;
        if (mdvGuidanceSuppressedSync_(mdvCached.detectedCountry)) return;
        mdvGuidanceStyles_();
        document.documentElement.classList.add('mdvGeoBanner-active');
    } catch (mdvGuidanceEarlyError) {}
})();

function openCountrySelectorPopup() {
    setTimeout(function () {
            if (shouldOpenCountrySelector()) {
                // Only a prompt WE raised should be snoozable on dismissal --
                // not the selector opened deliberately from the header.
                window.mdvMismatchPromptOpen = Boolean(getCookie("selectedCountry"));
                mdvPrefillCurrencyForSelectedCountry_();
                $('.country-selector.custom-country-selector').addClass('active');
                $('body').addClass('no-scroll');
            }
    }, 4000);
}

// Currency the shopper choosing countryCode is actually charged in. Same
// authority order as getCurrencyByCountryCode: Shopify Markets map first,
// global hardcoded array second. Null = unknown (caller must fail open).
function mdvChargeCurrencyForCountry_(countryCode) {
    try {
        var mdvMap = window.mdvMarketCurrencies;
        if (mdvMap && typeof mdvMap[countryCode] === 'string' && /^[A-Z]{3}$/.test(mdvMap[countryCode])) {
            return mdvMap[countryCode];
        }
        for (var mdvI = 0; mdvI < countryCurrencyArray.length; mdvI++) {
            if (Object.keys(countryCurrencyArray[mdvI])[0] === countryCode) {
                return countryCurrencyArray[mdvI][countryCode].currency;
            }
        }
    } catch (mdvChargeCcyError) {}
    return null;
}
// Currency an offer line quotes, or null for currency-neutral lines. Explicit
// ISO code beats symbol. Covers every notation in countryOffers today; any
// unrecognised notation returns null, which fails open (line is shown).
function mdvOfferLineCurrency_(offerText) {
    var mdvCode = String(offerText).match(/\b(AUD|AED|CAD|USD|GBP|EUR)\b/);
    if (mdvCode) return mdvCode[1];
    if (offerText.indexOf('\u00A3') !== -1) return 'GBP';
    if (offerText.indexOf('\u20AC') !== -1) return 'EUR';
    if (offerText.indexOf('$') !== -1) return 'USD';
    return null;
}

function getActiveCountryOffers(countryCode) {
    const offersToShow = countryOffers.find(countryOffer => 
        countryOffer.countryCodes.includes(countryCode) || countryOffer.countryCodes.includes("ALL")
    );
    const offers = offersToShow ? offersToShow.offers : [];
    // Drop only lines quoting a currency the shopper is NOT charged in (e.g.
    // "400 AUD" copy for AED countries). Neutral lines stay, so no group can
    // empty (every group has at least one). Unknown charge currency, unknown
    // notation, or any error = show today's copy unchanged.
    var offersFiltered = offers;
    try {
        var mdvChargeCcy = mdvChargeCurrencyForCountry_(countryCode);
        if (mdvChargeCcy) {
            offersFiltered = offers.filter(function (mdvLine) {
                var mdvLineCcy = mdvOfferLineCurrency_(mdvLine);
                return !mdvLineCcy || mdvLineCcy === mdvChargeCcy;
            });
        }
    } catch (mdvOfferFilterError) { offersFiltered = offers; }
    let htmlContent = '<ul>';
    offersFiltered.forEach(offerText => {
        htmlContent += `<li><span class="text-unset">${offerText}</span></li>`;
    });
    htmlContent += '</ul>';
    $(".country-selector-offer").html(htmlContent);
}

function getLanguagesByCountryCode(countryCode) {
    $('.language-select ul.language-select-option li').removeClass("active");
    const country = countriesLanguages.find(c => c.country_code.includes(countryCode));
    $(".language-select-option li").hide();
    if (country) {
        country.languages.forEach((language, index) => {
            const languageSelector = `.language-select-option li[value="${language.code}"]`;
            $(languageSelector).show();
            if (index === 0) {
            $(languageSelector).addClass('active');
            $(".language-select-value").html(language.name);
            }
        });
        $(".country-col.language").show();
    } else {
        $(".country-col.language").hide();
    }
}

// Re-runnable form of the empty-header walk (unchanged body, extracted so that
// syncCurrencySelectorToActive can re-run it -- it shows a currency <li> AFTER
// getCurrencyByCountryCode has already reconciled the headers, which left the
// "suggested currencies" heading hidden while GBP was visible under it on live UK).
function mdvReconcileCurrencyHeaders_() {
    // Hide any currency group header that has no visible items, and restore it
    // when it does. Single-currency markets (US/EU/AU/CA) otherwise render a
    // dangling empty heading. Uses setProperty(...,'important') because the
    // snippet forces span.option-label{display:block!important}, which a plain
    // inline style cannot override. Wrapped defensively: this runs before
    // setActiveCoutry/getLanguagesByCountryCode in the same handler chain.
    try {
        var mdvCcyList = document.querySelector('.price-select ul.small');
        if (mdvCcyList) {
            var mdvHeader = null;
            var mdvShown = 0;
            var mdvApply = function (header, shown) {
                if (!header) return;
                if (shown === 0) header.style.setProperty('display', 'none', 'important');
                else header.style.removeProperty('display');
            };
            for (var mdvI = 0; mdvI < mdvCcyList.children.length; mdvI++) {
                var mdvNode = mdvCcyList.children[mdvI];
                if (mdvNode.classList && mdvNode.classList.contains('option-label')) {
                    mdvApply(mdvHeader, mdvShown);
                    mdvHeader = mdvNode;
                    mdvShown = 0;
                } else if (mdvNode.tagName === 'LI' && mdvNode.style.display !== 'none') {
                    mdvShown++;
                }
            }
            mdvApply(mdvHeader, mdvShown);
        }
    } catch (mdvHeaderErr) {}
}

// WS2: compose "suggested currencies" from the shopper's selected country instead
// of the hardcoded GBP/AED/ALL/AMD/CHF list.
//
//   native    = window.mdvMarketCurrencies[country] -- Shopify Markets, i.e. the
//               currency THIS store actually charges that country. The map only
//               covers the countries this store serves; when the selected country
//               routes to a different store the map is silent BY DESIGN, so we fall
//               back to that destination bucket's home currency (same mapping as the
//               setdefaultCurrency branches above).
//   secondary = GCC six -> AED, Europe (incl. GB) -> EUR, everywhere else -> USD.
//               Appended only where it differs from native AND the bucket filter
//               already shows it -- in practice the Gulf combos SA/KW/QA on the ME
//               store. It is NEVER force-shown: promoting a display currency the
//               store cannot serve natively drops search to its native fallback
//               (Worker 409, "full search isn't available right now"), so offering
//               it would be a downgrade. Deliberately deferred, pending search
//               support for non-native display currencies.
//
// Only the map-derived native may be force-shown past the bucket filter: that entry
// is what Shopify actually charges this shopper, so surfacing it is a fix, not a new
// risk. No other bucket-foreign currency is ever revealed.
//
// Nodes are MOVED, never cloned. The currency click handlers are bound directly to
// these <li> elements, so a clone would silently lose them and would also duplicate
// value=, breaking both the li[value=X] label lookup and the li.active read that
// feeds selectedPrice on Update.
function mdvBuildSuggestedCurrencies_(countryCode, currencyShow) {
    try {
        var mdvList = document.querySelector('.price-select ul.small');
        if (!mdvList) return;
        mdvList.setAttribute('data-mdv-suggested-build', 'MDV-WS2-SUGGESTED-CCY-20260811-A');

        var mdvKids = Array.prototype.slice.call(mdvList.children);
        var mdvHeads = [];
        for (var mdvA = 0; mdvA < mdvKids.length; mdvA++) {
            if (mdvKids[mdvA].classList && mdvKids[mdvA].classList.contains('option-label')) {
                mdvHeads.push(mdvKids[mdvA]);
            }
        }
        if (mdvHeads.length < 2) return;
        var mdvSugHead = mdvHeads[0];
        var mdvAllHead = mdvHeads[1];

        // One-time canonical order for the "all currencies" group. The five
        // originally-hardcoded suggestions are folded in alphabetically so that
        // demoting them does not leave them clustered out of order at the top.
        if (!mdvList.mdvBaseOrder) {
            var mdvBase = [];
            var mdvWasSug = [];
            var mdvSeenAll = false;
            for (var mdvB = 0; mdvB < mdvKids.length; mdvB++) {
                var mdvK = mdvKids[mdvB];
                if (mdvK === mdvAllHead) { mdvSeenAll = true; continue; }
                if (mdvK.tagName !== 'LI') continue;
                if (mdvSeenAll) { mdvBase.push(mdvK); } else { mdvWasSug.push(mdvK); }
            }
            for (var mdvC = 0; mdvC < mdvWasSug.length; mdvC++) {
                var mdvVal = mdvWasSug[mdvC].getAttribute('value') || '';
                var mdvAt = mdvBase.length;
                for (var mdvD = 0; mdvD < mdvBase.length; mdvD++) {
                    if ((mdvBase[mdvD].getAttribute('value') || '') > mdvVal) { mdvAt = mdvD; break; }
                }
                mdvBase.splice(mdvAt, 0, mdvWasSug[mdvC]);
            }
            mdvList.mdvBaseOrder = mdvBase;
        }

        // ---- the one curated place for region -> secondary currency ----
        var mdvBucketHome = { "UK": "GBP", "US": "USD", "EU": "EUR", "CA": "CAD", "ME": "AED", "AU": "AUD" };
        var mdvGcc = ["AE", "SA", "KW", "QA", "BH", "OM"];
        var mdvEurope = ["AD", "AL", "AT", "AX", "BA", "BE", "BG", "BY", "CH", "CY", "CZ", "DE",
                         "DK", "EE", "ES", "FI", "FO", "FR", "GB", "GG", "GI", "GL", "GR", "HR",
                         "HU", "IE", "IM", "IS", "IT", "JE", "LI", "LT", "LU", "LV", "MC", "MD",
                         "ME", "MK", "MT", "NL", "NO", "PL", "PT", "RO", "RS", "RU", "SE", "SI",
                         "SK", "SM", "UA", "VA", "XK"];
        // IL, TR and EG are deliberately NOT in the GCC list -- they take the USD
        // default. "ME" in mdvEurope is Montenegro, not the ME store bucket.

        var mdvNative = null;
        var mdvForce = false;
        try {
            var mdvMap = window.mdvMarketCurrencies;
            if (mdvMap && typeof mdvMap[countryCode] === 'string' && /^[A-Z]{3}$/.test(mdvMap[countryCode])) {
                mdvNative = mdvMap[countryCode];
                mdvForce = true;
            }
        } catch (mdvMapErr) {}
        if (!mdvNative) { mdvNative = mdvBucketHome[currencyShow] || null; }

        var mdvSecondary = "USD";
        if (mdvGcc.indexOf(countryCode) !== -1) { mdvSecondary = "AED"; }
        else if (mdvEurope.indexOf(countryCode) !== -1) { mdvSecondary = "EUR"; }

        var mdvTargets = [];
        var mdvAdd = function (mdvCode, mdvMayForce) {
            if (!mdvCode) return false;
            for (var mdvE = 0; mdvE < mdvTargets.length; mdvE++) {
                if (mdvTargets[mdvE].getAttribute('value') === mdvCode) return true;
            }
            var mdvEl = mdvList.querySelector('li[value="' + mdvCode + '"]');
            if (!mdvEl) return false;
            if (mdvEl.style.display === 'none') {
                if (!mdvMayForce) return false;
                mdvEl.style.display = 'list-item';
            }
            mdvTargets.push(mdvEl);
            return true;
        };
        // If Shopify Markets has moved a country onto a currency that the static 87-item
        // <li> list does not carry yet (Markets drift outrunning the theme), there is no
        // node to promote -- fall back to the destination bucket's home currency.
        if (!mdvAdd(mdvNative, mdvForce)) { mdvAdd(mdvBucketHome[currencyShow], true); }
        mdvAdd(mdvSecondary, false);

        var mdvDesired = [mdvSugHead];
        for (var mdvF = 0; mdvF < mdvTargets.length; mdvF++) { mdvDesired.push(mdvTargets[mdvF]); }
        mdvDesired.push(mdvAllHead);
        var mdvRest = mdvList.mdvBaseOrder;
        for (var mdvG = 0; mdvG < mdvRest.length; mdvG++) {
            if (mdvTargets.indexOf(mdvRest[mdvG]) === -1) { mdvDesired.push(mdvRest[mdvG]); }
        }

        var mdvNow = Array.prototype.slice.call(mdvList.children);
        var mdvSame = mdvNow.length === mdvDesired.length;
        if (mdvSame) {
            for (var mdvH = 0; mdvH < mdvDesired.length; mdvH++) {
                if (mdvNow[mdvH] !== mdvDesired[mdvH]) { mdvSame = false; break; }
            }
        }
        if (!mdvSame) {
            for (var mdvI = 0; mdvI < mdvDesired.length; mdvI++) { mdvList.appendChild(mdvDesired[mdvI]); }
        }
    } catch (mdvSugErr) {}
}

function getCurrencyByCountryCode(countryCode, hideDropdown) {
    $('.price-select .small li').removeClass('active').hide();

    const result = countryCurrencyArray.filter(item => {
        const country = Object.keys(item)[0];
        return country === countryCode;
    });
    var currencyShow = $('.country-selector-select .country-selector-option li[data-code="' + countryCode + '"]').attr('data-currency');
    let setdefaultCurrency = false;

    // Shopify Markets is the authority on which currency a country is priced in.
    // window.mdvMarketCurrencies is rendered from localization.available_countries
    // (store-level config, identical for every visitor, so CDN-cache-safe). The
    // hardcoded countryCurrencyArray below is a stale GLOBAL list shared across all
    // six stores -- on UK alone it disagreed with Shopify for AD, MC and NO -- so it
    // is now only a fallback for countries Shopify does not enumerate for this store.
    var mdvResolvedCurrency = null;
    try {
        var mdvCcyMap = window.mdvMarketCurrencies;
        if (mdvCcyMap && typeof mdvCcyMap[countryCode] === 'string' && /^[A-Z]{3}$/.test(mdvCcyMap[countryCode])) {
            mdvResolvedCurrency = mdvCcyMap[countryCode];
        }
    } catch (mdvCcyMapError) {}
    if (!mdvResolvedCurrency && result.length > 0) {
        mdvResolvedCurrency = result[0][countryCode].currency;
    }

    if (mdvResolvedCurrency) {
        const currency = mdvResolvedCurrency;
        // Guarded: Shopify enumerates countries the hardcoded array does not, so
        // result[] can legitimately be empty here. (Unused downstream, kept for
        // parity with the original.)
        const countryName = result.length > 0 ? result[0][countryCode].country : '';
        const currencyElement = $('.price-select .small li[value="' + currency + '"]');
        if (currencyElement.length) {
            currencyElement.addClass('active');
            $('.price-select-value').html(currencyElement.html());
        } else {
            setdefaultCurrency = true;
        }
    } else {
        setdefaultCurrency = true;
    }
    if (setdefaultCurrency === true && currencyShow === "ME") {
        $('li[value="AED"]').addClass('active');
        $('.price-select-value').html($('li[value="AED"]').html());
    } else if (setdefaultCurrency === true && currencyShow === "UK") {
        $('li[value="GBP"]').addClass('active');
        $('.price-select-value').html($('li[value="GBP"]').html());
    } else if (setdefaultCurrency === true && currencyShow === "US") {
        $('li[value="USD"]').addClass('active');
        $('.price-select-value').html($('li[value="USD"]').html());
    } else if (setdefaultCurrency === true && currencyShow === "EU") {
        $('li[value="EUR"]').addClass('active');
        $('.price-select-value').html($('li[value="EUR"]').html());
    } else if (setdefaultCurrency === true && currencyShow === "CA") {
        $('li[value="CAD"]').addClass('active');
        $('.price-select-value').html($('li[value="CAD"]').html());
    } else if (setdefaultCurrency === true && currencyShow === "AU") {
        // WS2-1: the AU bucket had no default branch, so an AU-bucket country whose
        // currency is absent from the list fell through with no active currency at
        // all. Load-bearing for the suggested-list fallback, which uses this same
        // bucket -> home-currency mapping.
        $('li[value="AUD"]').addClass('active');
        $('.price-select-value').html($('li[value="AUD"]').html());
    }

    $('.price-select .small li[data-code="' + currencyShow + '"]').show();

    mdvBuildSuggestedCurrencies_(countryCode, currencyShow);

    mdvReconcileCurrencyHeaders_();

}

function setActiveCoutry(ShopifyCountry) {
    $('.custom-country-selector .country-selector-select li[data-code="' + ShopifyCountry + '"]').addClass('active');
    $('.country-selector-zone').val(
        $('.custom-country-selector .country-selector-select li[data-code="' + ShopifyCountry + '"]').html()
    );

    var autoHref = $('.country-selector-select .country-selector-option li.active').attr('data-href');
    if ($('.country-col.language').is(':visible')) {
        languageValue = "?"+$('.language-select-option li.active').attr('value')+"&";
    } else {
        var languageValue = '';
    }
    
    // alert('New URL 1=  '+ autoHref + languageValue);

    if (getCookie('selectedCountry')) {
        if (autoHref !== window.location.origin && !getCookie('stop_redirect')) {
            if (autoHref) {
                var redirection_url;
                try {
                    if (!window.MDVMarketRedirect) throw new Error('MDVMarketRedirect unavailable');
                    redirection_url = window.MDVMarketRedirect.buildMarketRedirectUrl(autoHref, window.location.href, languageValue);
                } catch (mdvRedirectError) {
                    redirection_url = autoHref + window.location.pathname + languageValue;
                }
                // window.location.href = redirection_url;
            } else {
                $('.country-selector-btn .country-selector-error').show();
            }
        }
    }
}

function updateCurrency(newCurrency) {
    fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
            fetch('/cart/update.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    updates: cart.items.reduce((acc, item) => {
                        acc[item.id] = item.quantity;
                        return acc;
                    }, {}),
                    currency: newCurrency
                }),
            })
            .then(response => response.json())
            .then(updatedCart => {
                document.cookie = "currency=; path=/; domain=.manieredevoir.com; expires=Thu, 01 Jan 1970 00:00:00 GMT; secure";

                // location.reload();
            })
            .catch(error => console.error('Error updating cart:', error));
        })
        .catch(error => console.error('Error fetching cart:', error));
}

// Example of how to call the function to update the currency
 // Use the desired currency code, like 'USD', 'GBP', 'EUR'

// Reconcile the visible currency label to Shopify's actual resolved active
// currency on page load. getCurrencyByCountryCode() derives the label from a
// *country* source (the selectedCountry cookie, or the IP-detected browsing
// context) which can disagree with the storefront currency Shopify actually
// resolved for the session -- e.g. the selector showed "USD $" while
// Shopify.currency.active (and the cart_currency cookie) were "GBP". This makes
// the server-resolved active currency the last word at init. It is invoked only
// from runCountryFunctions (page-load init), never from the in-modal country
// click handler, so the modal's normal country/currency preview flow is
// preserved exactly.
function syncCurrencySelectorToActive() {
    if (!(window.Shopify && Shopify.currency && Shopify.currency.active)) return;
    var activeCurrency = Shopify.currency.active;
    var activeEl = $('.price-select .small li[value="' + activeCurrency + '"]').first();
    if (!activeEl.length) return; // active currency not in the list -> leave country-derived label untouched
    $('.price-select .small li').removeClass('active');
    activeEl.addClass('active').show();
    mdvReconcileCurrencyHeaders_();
    $('.price-select-value').html(activeEl.html());
}

function runCountryFunctions(customerTargetCountry){
    setStopRedirect();
    getActiveCountryOffers(customerTargetCountry);
    getCurrencyByCountryCode(customerTargetCountry, true);
    setActiveCoutry(customerTargetCountry);
    getLanguagesByCountryCode(customerTargetCountry);
    // openCountrySelectorPopup();
    // Don't repaint the label while an auto-opened prompt is on screen -- that is
    // what produced the "Ship to USA / currency GBP" contradiction.
    if (!$('.country-selector.custom-country-selector').hasClass('active')) {
        syncCurrencySelectorToActive();
    }
}


// The selectedCountry cookie is domain-wide and has always persisted, but until
// now nothing ever applied it: a shopper who picked the United States still
// landed on whichever store they typed, and only got a prompt about it. This
// applies the stored choice, at most once per session.
//
// Deliberately conservative: every guard below is a reason NOT to move, and any
// unexpected state (blocked storage, unrecognised host, un-allowlisted
// destination) aborts rather than guesses. Crawlers carry no selectedCountry
// cookie, so this can never fire for Googlebot -- www keeps serving UK content
// to search engines by construction.
//
// This is NOT the commented-out redirect in setActiveCoutry: that one compares
// origins, so it would hop eu. -> dk. inside a single market. This compares
// markets, via mdvSelectedCountryForThisStore.
function mdvMaybeApplyStoredCountry_() {
    try {
        var mdvStored = getCookie('selectedCountry');
        // 1. A stored choice must exist and look like a country code.
        if (!mdvStored || !/^[A-Z]{2,3}$/.test(mdvStored)) return false;
        // 2. Escape hatch. ?stop_redirect=true is normally persisted by
        //    setStopRedirect inside runCountryFunctions, which runs after this --
        //    too late to stop a redirect. Persist it here first so appending the
        //    param works as an escape on the very load you append it to.
        try { setStopRedirect(); } catch (mdvStopRedirectError) {}
        if (getCookie('stop_redirect')) return false;
        // 3. They already declined this exact switch (30-day snooze).
        if (getCookie('mdvMismatchDismissed') === mdvStored) return false;
        // 4. Never route automation or crawlers.
        if (navigator && navigator.webdriver) return false;
        // 5. ?country= is single-hop control state that ME's selector consumes on
        //    load to write the cookie; bouncing that request would break campaign
        //    links and fight the value being set.
        if (new URLSearchParams(location.search).get('country') !== null) return false;
        var mdvScope = '.country-selector-select .country-selector-option li';
        // 6. If this host is not represented in the selector we cannot tell which
        //    market it is, and every stored country would look foreign. Stay put.
        //    Same reasoning as shouldOpenCountrySelector.
        if (!document.querySelector(mdvScope + '[data-href="' + location.origin + '"]')) return false;
        // 7. Market-level, not origin-level: a store that already serves this
        //    country keeps the visitor, so FR on eu. and NO on www never hop.
        if (typeof window.mdvSelectedCountryForThisStore !== 'function') return false;
        if (window.mdvSelectedCountryForThisStore()) return false;
        // 8. The destination must be known, and actually be somewhere else.
        var mdvTarget = document.querySelector(mdvScope + '[data-code="' + mdvStored + '"]');
        var mdvTargetHref = mdvTarget && mdvTarget.getAttribute('data-href');
        if (!mdvTargetHref || mdvTargetHref === location.origin) return false;
        // 9. Once per session, claimed BEFORE navigating so no chain of hops can
        //    loop. Blocked storage aborts the redirect entirely (fail closed) --
        //    the same rule the mismatch prompt already uses.
        try {
            if (sessionStorage.getItem('mdvAutoRouted') === '1') return false;
            sessionStorage.setItem('mdvAutoRouted', '1');
        } catch (mdvAutoRouteStorageError) {
            return false;
        }
        // 10. Allowlisted builder only: it validates the destination, drops the
        //     single-hop country/currency params and preserves UTMs and the path.
        //     Any throw aborts rather than falling back to a hand-built URL.
        var mdvRouteUrl;
        try {
            if (!window.MDVMarketRedirect) throw new Error('MDVMarketRedirect unavailable');
            mdvRouteUrl = window.MDVMarketRedirect.buildMarketRedirectUrl(mdvTargetHref, window.location.href);
        } catch (mdvAutoRouteBuildError) {
            return false;
        }
        if (!mdvRouteUrl) return false;
        // replace(), not href, so Back does not drop the shopper straight back into
        // the store they were just routed out of.
        window.location.replace(mdvRouteUrl);
        return true;
    } catch (mdvAutoRouteError) {
        return false;
    }
}

// Safari's ITP caps JS-set cookies at roughly 7 days, so the 365-day expiry the
// Update button writes decays long before it should. Rewriting the cookie on each
// load renews that window for anyone who keeps visiting; only genuinely lapsed
// shoppers fall back to cookieless, where the geo prompt takes over.
//
// Written with exactly the attributes the Update button uses. A host-only write
// here would create a SECOND selectedCountry cookie shadowing the domain-wide one
// on this host only, which is worse than not refreshing at all.
function mdvRefreshSelectedCountryCookie_() {
    try {
        var mdvStored = getCookie('selectedCountry');
        if (!mdvStored || !/^[A-Z]{2,3}$/.test(mdvStored)) return;
        document.cookie = "selectedCountry=" + mdvStored + "; expires=" + new Date(Date.now() + 365*24*60*60*1000).toUTCString() + "; path=/; domain=.manieredevoir.com; secure";
    } catch (mdvRefreshError) {}
}

$(document).ready(function() {

    // Renew the stored choice, then apply it. Both are no-ops without a valid
    // selectedCountry cookie, so a first-time visitor is unaffected.
    mdvRefreshSelectedCountryCookie_();
    mdvMaybeApplyStoredCountry_();

    if (!getCookie('stop_redirect')) {
        updateCountryFlag();
    }

    if(getCookie('selectedCountry')){
        var customerTargetCountry = getCookie('selectedCountry');
        runCountryFunctions(customerTargetCountry);
    }else{
        // A session that has already mounted the banner once does not ask the geo
        // endpoint again: the country is known, so the selector is populated from
        // the cached value and the bar drops into the space the early path already
        // reserved. Trade-off: a mid-session VPN/location change is not noticed
        // until the next session.
        var mdvSession = mdvGuidanceCacheRead_();
        if (mdvSession) {
            runCountryFunctions(mdvSession.detectedCountry);
            mdvMaybeShowGuidanceCached_();
            // Fail-closed: if that attempt did not leave a banner in the DOM, the
            // reserved band is removed now rather than left as dead space.
            mdvGuidanceVerifyMounted_();
        } else {
            fetch('/browsing_context_suggestions.json')
            .then(r => r.json())
            .then(d => {
                var customerTargetCountry = d.detected_values.country.handle;
                runCountryFunctions(customerTargetCountry);
                // Was mdvMaybeGeoOpen_ -- the auto-opening geo modal is retired in
                // favour of the dismissible top bar / cart notice.
                mdvMaybeShowGuidance_(customerTargetCountry);
            })
            .catch(function mdvGeoFetchFailed() {});
        }
    }
    openCountrySelectorPopup();

    if(getCookie('customCurrency')){
        updateCurrency(getCookie('customCurrency')); 
    }
    
    // open popup
    $(document).on("click",'.header-style-one ul.header-right-icon li.country, .pass-right-icon',function(event) {
        event.preventDefault();
        $('.country-selector.custom-country-selector').addClass('active');
        $('body').addClass('no-scroll');
    });
    // close popup
    $(".custom-country-selector .country-selector-close, .country-selector .main-overlay").on("click", function () {
        // Only the explicit X close counts as "no thanks". An overlay click is
        // the accidental-dismissal path -- this overlay was intercepting clicks
        // meant for the cookie banner -- so it closes the modal but must never
        // write a 30-day snooze, which would also suppress the stored-country
        // auto-route for a month.
        var mdvExplicitClose = $(this).hasClass('country-selector-close');
        $(".custom-country-selector.country-selector").removeClass("active");
        $('body').removeClass('no-scroll');
        setCookie("show_redirection", true, '365');
        // Declining a mismatch prompt snoozes it for 30 days for that country.
        // Long enough not to nag a deliberate cross-shopper every visit, short
        // enough that someone stranded by accident gets asked again.
        if (window.mdvMismatchPromptOpen) {
            if (mdvExplicitClose) {
                var dismissed = getCookie("selectedCountry");
                if (dismissed) setCookie("mdvMismatchDismissed", dismissed, '30');
            }
            window.mdvMismatchPromptOpen = false;
        }
        // Declining the geo prompt snoozes it for 30 days for that country, so a
        // deliberate cross-border shopper is not nagged every visit.
        if (window.mdvGeoPromptOpen) {
            if (mdvExplicitClose) {
                setCookie("mdvGeoDismissed", window.mdvGeoPromptOpen, '30');
            }
            window.mdvGeoPromptOpen = false;
        }
        // Shopper stayed rather than switching: put the label back to the currency
        // Shopify is actually charging, so it never contradicts the live prices.
        // Label/li only -- must NOT touch ME's .currency-picker, which would
        // re-convert every visible price mid-session.
        try { if (typeof syncCurrencySelectorToActive === 'function') syncCurrencySelectorToActive(); } catch (mdvSyncError) {}
    });
    // toggle country list
    $(".country-selector-select-arrow").click(function(){
        $(".country-selector-select").toggleClass("active");
        $(".country-selector-option ").toggleClass("active");
    });
    // toggle price
    $(".price-select-arrow").click(function(){
        $(".price-select").toggleClass("active");
        $(".price-select .small").toggleClass("active");
    });
    // toggle language
    $(".language-select-arrow").click(function(){
        $(".language-select").toggleClass("active");
        $(".language-select-option").toggleClass("active");
    });
    // search country 
    $('.country-selector-zone').on("keyup", function () {
        var current_search = $(this).val().toLowerCase();
        $("ul.country-selector-option li").show();
        $("ul.country-selector-option li").each(function (index) {
            var search_match = $(this).attr("value").toLowerCase();
            if (search_match.indexOf(current_search) == 0) {
                $(this).show();
            } else {
                $(this).hide();
            }
        });
        if ($(this).val().length >= 1) {
            $('.country-selector-option .option-label').hide();
        } else {
            $(".country-selector-option .option-label").show();
        }
    });
    // open price list
    $('.price-select-value').on("click", function () {
        $(this).next(".price-select .small").addClass("active");
        $(this).parents('.price-select').addClass("active");
    });
    // select price li
    $('.custom-country-selector .country-selector-form .price-select li').on("click", function () {
        $('.custom-country-selector .country-selector-form .price-select li').removeClass('active');
        $(this).addClass('active');
        $('.custom-country-selector .country-selector-form .price-select-value').html($('.custom-country-selector .country-selector-form .price-select li[value=' + $(this).attr("value") + ']').html());
        $(this).parents("ul.small").removeClass('active');
        $(this).parents('.price-select').removeClass("active");
    });
    // select country li
    $('.custom-country-selector .country-selector-select li').on("click", function () {
        $('.custom-country-selector .country-selector-select li').removeClass("active");
        $(this).addClass("active");
        $('.country-selector-zone').val($(this).attr("value"));
        getActiveCountryOffers($(this).attr("data-code"));
        getCurrencyByCountryCode($(this).attr("data-code"));
        getLanguagesByCountryCode($(this).attr("data-code"));
        $(this).parents("ul").removeClass("active");
    });
    // open country list
    $('.country-selector-zone').on("click", function () {
        $(this).next("ul.country-selector-option").addClass("active");
        $(this).parents('.country-selector-select').addClass("active");
    });
    // clear on focus so typing filters from scratch; restore on blur if the
    // shopper picked nothing. Restore source is li.active (single source of
    // truth). Value+placeholder+alignment only: never changes country, never
    // opens or closes anything. Restore-if-empty + the li click handler's
    // unconditional .val() write makes blur/click ordering irrelevant.
    $('.country-selector-zone').on("focus", function () {
        $(this).attr("placeholder", "Search Country").css("text-align", "start").val("").trigger("keyup");
    });
    $('.country-selector-zone').on("blur", function () {
        $(this).attr("placeholder", "Select Country").css("text-align", "");
        if ($(this).val() !== "") return;
        var activeCountryName = $('.custom-country-selector .country-selector-select li.active').attr("value");
        if (activeCountryName) $(this).val(activeCountryName);
    });
    // open language list
    $('.language-select-value').on("click", function () {
        $(this).next("ul.language-select-option").addClass("active");
        $(this).parents('.language-select').addClass("active");
    });
    // select language li
    $('.language-select ul.language-select-option li').on("click", function () {
        $('.language-select ul.language-select-option li').removeClass("active");
        $(this).addClass("active");
        $(this).parents(".language-select").find(".language-select-value").html($(this).html());
        $(this).parents("ul.language-select-option").removeClass("active");
        $(this).parents('.language-select').removeClass("active");
    });
    // Update Button 
    $(".custom-country-selector button#change_country").on("click", function (event) {
        event.preventDefault();

        var dataHref = $('.country-selector-select .country-selector-option li.active').attr('data-href');
        var selectedPrice = $('.price-select .small li.active').attr('value');
        var selectedCountry = $('.country-selector-select .country-selector-option li.active').attr('data-code')
        if ($('.country-col.language').is(':visible')) {
            var languageValue = "?"+$('.language-select-option li.active').attr('value')+"&";
        } else {
            var languageValue = '';
        }
        if (dataHref) {
            setCookie("show_redirection", true, '365');
            var redirection_url;
            try {
                if (!window.MDVMarketRedirect) throw new Error('MDVMarketRedirect unavailable');
                redirection_url = window.MDVMarketRedirect.buildMarketRedirectUrl(dataHref, window.location.href, languageValue, selectedPrice);
            } catch (mdvRedirectError) {
                redirection_url = dataHref + window.location.pathname + languageValue;
            }
            document.cookie = "customCurrency=" + selectedPrice + "; expires=" + new Date(Date.now() + 365*24*60*60*1000).toUTCString() + "; path=/; domain=.manieredevoir.com; secure";
            document.cookie = "selectedCountry=" + selectedCountry + "; expires=" + new Date(Date.now() + 365*24*60*60*1000).toUTCString() + "; path=/; domain=.manieredevoir.com; secure";
            
            // alert('New URL =  '+ redirection_url);

            // setTimeout(function() {
                window.location.href = redirection_url;
            // }, 1000);
            
        } else {
            $('.country-selector-btn .country-selector-error').show();
        }

    });

    // Last word on the reserved band, on EVERY ready path -- not just the cached
    // branch. The early path can apply the compensation at script-execution time
    // and then a selectedCountry cookie can land before ready (another tab, an
    // app, an extension), which sends this handler down the stored-country branch
    // where the cached-path check never runs. Without this call that pageview
    // keeps 46/62px of dead space. No-op whenever the early class is absent.
    mdvGuidanceVerifyMounted_();
});


// close all list
$(document).on('click', function (event) {
    if (!$(event.target).closest('.price-select').length) {
        $(".price-select .small").removeClass("active");
        $('.price-select').removeClass("active");
    }
    if (!$(event.target).closest('.country-selector-select').length) {
        $(".country-selector-select").removeClass("active");
        $(".country-selector-option ").removeClass("active");
    }
    if (!$(event.target).closest('.language-select').length) {
        $(".language-select").removeClass("active");
        $(".language-select-option").removeClass("active");
    }
});

